import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=1892aca4&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"
import style0 from "./Splash.vue?vue&type=style&index=0&id=1892aca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1892aca4",
  null
  
)

export default component.exports